import React,{useState, useEffect} from 'react';
import {PostSaveMyPost} from '../../services/servicesPostSaveMyPost';
import {InsertPost} from '../../services/servicesInsertPost';
import LoadScreen from '../../components/loadScreen/loadScreen';
import {Post,
    Button,
    SpanButton,
    DivPaiImage,
    DivImg,
    DivImgLiberado,
    ImgLiberado,
    LabelImageEditPost,
    InputTituloPost,
    DivTextPost,
    TextAreaTextPost,
    DivPaiImagePostLiberado,
    DivButtonSave,
    DivTextTitleText} from './styledClientes';
import Popup from "reactjs-popup";
import Toastify from '../../components/Toastify';
import InputFile from '../../components/inputs/inputFile/InputFile';
import {IconMdBorderColor} from '../../components/menu/styles';


export default function NovoTemplate(props){
    const img404 = require('../../assets/images/noData.png').default;
    const [fotoCarregada, setFotoCarregada] = useState(true);

    const [conteudoPost, setConteudoPost] = useState({Id:'',
    Image1:img404,
    PostText:'',
    PostTitle:'',
    Category:'',
    Date:'',
    PopularCount:'',
    KeyWords:''});
//configuração do toastify
    const [statusToastify, setStatusToastify]=useState('');
    const customId  = 'custom-id-yes';
    const Sucess = (mensagem) => Toastify.success(mensagem,{toastId:customId} );
    const Error = (mensagem) => Toastify.error(mensagem,{toastId:customId});

//fim configuração do toastify

    useEffect(()=>{
        Sucess('Preencha os campos')
    },[]);

    function editaTexto(event){
        event.preventDefault();
        setConteudoPost({...conteudoPost,PostText:event.target.value});
    };

    function editaTitulo(event){
        event.preventDefault();
        setConteudoPost({...conteudoPost,PostTitle:event.target.value});
    };

   async function salvarPost(){
        try {
            const salvandoPost = await InsertPost(conteudoPost);
                if (salvandoPost !== 400){
                Sucess('Post Salvo com sucesso');
            }else{
                Error('Não foi possível salvar o post');
            }
        }catch (error) {
            Error('Erro ao tentar realizar o insert post');
        }

    }

    function erroPost(){
        Error();
    }

    return(<Post>
        <DivPaiImage>
                <DivPaiImagePostLiberado>
                    <div style={{height:'40px',marginBottom:'20px',display:'flex', justifyContent:'space-evenly'}}>
                        <InputFile mudaImg = {setConteudoPost}
                            imagem={conteudoPost}
                            load={fotoCarregada}
                            campo='Image1'
                            concluido={setFotoCarregada}/>
                        <Button>
                            <SpanButton>Utilizar Editor</SpanButton>
                        </Button>
                    </div>
                    <DivImg>
                        <DivImgLiberado>
                            {
                                fotoCarregada ?
                                    <ImgLiberado id='canvas' src={conteudoPost.Image1} />
                                :
                                    <LoadScreen position='unset' />
                            }
                            <LabelImageEditPost htmlFor='FotoEditaPost'style={{position:'relative',bottom:'calc(100vh * 0.35)',height:'0'}}>
                                <IconMdBorderColor style={{fontSize:'40pt'}}/>
                            </LabelImageEditPost>
                        </DivImgLiberado>
                    </DivImg>
                </DivPaiImagePostLiberado>
        </DivPaiImage>
        <DivTextTitleText>
            <DivButtonSave>
                <Button onClick={salvarPost}>
                    <SpanButton>Salvar</SpanButton>
                </Button>
            </DivButtonSave>
                <InputTituloPost
                    placeholder='Insira o título do texto'
                    value={conteudoPost.PostTitle}
                    onChange={(event)=>{editaTitulo(event)}}
                />
            <DivTextPost id='divtextpost' >
                    <TextAreaTextPost
                        placeholder='Insira o conteúdo do post'
                        value={conteudoPost.PostText}
                        onChange={(event)=>{editaTexto(event)}}
                    />
            </DivTextPost>

        </DivTextTitleText>
    </Post>)
}
